import { create } from "zustand";
import { IDLE_TIMEOUT } from "../constants/Common";

const onlineInfoStore = create((set, get) => ({
  onlines: {},  // Lưu trữ bản đồ của từng player
  timeouts: {}, // Lưu timeout của từng player để hủy nếu có cập nhật mới

  setOnline: (playerId, newStatus) => {
    if (newStatus != get().onlines[playerId]) {
      set((state) => ({
        onlines: {
          ...state.onlines,
          [playerId]: newStatus,
        },
      }));
    }

    // Nếu đã có timeout, clear nó trước
    if (get().timeouts[playerId]) {
      clearTimeout(get().timeouts[playerId]);
    }

    if (newStatus == true) {
      // Đặt timeout để xóa playerId sau 15 giây nếu không có cập nhật mới
      const timeoutId = setTimeout(() => {
        set((state) => {
          const newStatus = { ...state.onlines };
          delete newStatus[playerId];
          return { onlines: newStatus };
        });

        // Xóa timeout khỏi danh sách
        set((state) => {
          const newTimeouts = { ...state.timeouts };
          delete newTimeouts[playerId];
          return { timeouts: newTimeouts };
        });
      }, IDLE_TIMEOUT.OFFLINE_STATUS);

      // Cập nhật danh sách timeout
      set((state) => ({
        timeouts: {
          ...state.timeouts,
          [playerId]: timeoutId,
        },
      }));
    }
  },
}));

export default onlineInfoStore;
